export const getPopupContainer = (node) => {
    // 表单 && 查询
    // if (
    //   node &&
    //   (node.classList.contains('pro-field') ||
    //     node.classList.contains('ant-tabs-nav-more'))
    // ) {
    //   return node.parentNode as HTMLElement;
    // }
    // return document.body as HTMLElement;
    return document.getElementById('content-layout');
};
